import React, { useState, Fragment } from 'react';
import { LayoutDashboardIcon, UsersIcon, FileTextIcon, SearchIcon } from 'lucide-react';
import { LaneType } from '../types';
interface SidebarProps {
  activeLane: LaneType;
  setActiveLane: (lane: LaneType) => void;
  counts: {
    leads: number;
    loans: number;
    retention: number;
  };
}
export function Sidebar({
  activeLane,
  setActiveLane,
  counts
}: SidebarProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const totalCount = counts.leads + counts.loans + counts.retention;
  const navItems = [{
    id: 'all' as const,
    label: 'All Contacts',
    icon: LayoutDashboardIcon,
    count: totalCount
  }, {
    id: 'leads' as const,
    label: 'Follow-Up',
    icon: UsersIcon,
    count: counts.leads
  }, {
    id: 'loans' as const,
    label: 'Working List',
    icon: FileTextIcon,
    count: counts.loans
  }];
  return <aside className={`bg-olympian-navy border-r border-olympian-border flex flex-col transition-all duration-300 z-10 shrink-0 ${isExpanded ? 'w-[220px]' : 'w-16'}`} onMouseEnter={() => setIsExpanded(true)} onMouseLeave={() => setIsExpanded(false)} data-id="element-214">
      <nav className="flex-1 py-3 flex flex-col gap-1 px-2" role="navigation" aria-label="Pipeline lanes" data-id="element-215">
        {navItems.map((item, idx) => {
        const isActive = activeLane === item.id;
        const Icon = item.icon;
        return <Fragment key={item.id} data-id="element-216">
              {idx === 1 && <div className="h-px bg-olympian-border mx-2 my-1" data-id="element-217" />}
              <button onClick={() => setActiveLane(item.id)} className={`flex items-center justify-between p-2.5 rounded-lg transition-all group relative overflow-hidden whitespace-nowrap
                  ${isActive ? 'bg-olympian-surface border border-olympian-border' : 'hover:bg-olympian-surface/50 border border-transparent'}`} aria-current={isActive ? 'page' : undefined} data-id="element-218">
                {isActive && <div className="absolute left-0 top-0 bottom-0 w-1 bg-olympian-gold rounded-l-lg" data-id="element-219" />}
                <div className="flex items-center gap-3" data-id="element-220">
                  <Icon className={`w-5 h-5 shrink-0 transition-colors ${isActive ? 'text-olympian-gold' : 'text-olympian-textMuted group-hover:text-theme'}`} data-id="element-221" />
                  {isExpanded && <span className={`text-sm font-medium transition-colors ${isActive ? 'text-theme' : 'text-olympian-textMuted group-hover:text-theme'}`} data-id="element-222">
                      {item.label}
                    </span>}
                </div>
                <span className={`text-xs font-bold rounded-full text-center transition-all
                    ${isActive ? 'bg-olympian-gold/20 text-olympian-gold' : 'bg-olympian-surface text-olympian-textMuted border border-olympian-border'}
                    ${isExpanded ? 'px-1.5 py-0.5 min-w-[22px]' : 'absolute right-1 top-1 text-[10px] px-1 py-0 min-w-[18px]'}
                  `} data-id="element-223">
                  {item.count}
                </span>
              </button>
            </Fragment>;
      })}
      </nav>

      <div className="p-3 border-t border-olympian-border" data-id="element-224">
        <div className={`flex items-center gap-3 text-olympian-textMuted bg-olympian-surface rounded-lg p-2 border border-olympian-border transition-all overflow-hidden whitespace-nowrap ${isExpanded ? 'cursor-text' : 'cursor-pointer'}`} data-id="element-225">
          <SearchIcon className="w-4 h-4 shrink-0" data-id="element-226" />
          {isExpanded && <input type="text" placeholder="Search contacts..." className="bg-transparent border-none outline-none text-sm text-theme w-full placeholder-olympian-textMuted" aria-label="Search contacts" data-id="element-227" />}
        </div>
      </div>
    </aside>;
}